<template>
  <div class="checkbox-group">
    <label
      v-for="(option, index) in normalizedOptions"
      :key="index"
      class="checkbox-option"
    >
      <input
        type="checkbox"
        :value="option.value"
        v-model="modelValueLocal"
        class="checkbox-input"
      />
      <span class="checkbox-label">{{ option.label }}</span>
    </label>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  options: { type: Array, required: true },
  // НЕ указываем строгий type: Array — чтобы проп мог принимать null
  modelValue: { required: false, default: null },
});

const emit = defineEmits(["update:modelValue"]);

const normalizedOptions = computed(() =>
  props.options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  )
);

const modelValueLocal = computed({
  get() {
    // если пришёл null — используем пустой массив для v-model чекбоксов
    return Array.isArray(props.modelValue) ? props.modelValue : [];
  },
  set(val) {
    // если пустой массив — эмитим null (если хотите именно такую семантику)
    emit("update:modelValue", val.length ? val : null);
  },
});
</script>

<style scoped>
.checkbox-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.checkbox-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border: 0.1rem solid #ddd;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
	line-height: 1;
	height: fit-content;
	font-weight: 100;
}

.checkbox-option:hover {
  border-color: #666;
}

.checkbox-input {
  display: none;
}

.checkbox-input:checked + .checkbox-label {
  font-weight: 600;
  color: var(--color-1);
  transition: 0.3s ease all;
}

.checkbox-label {
  transition: 0.2s ease;
}
</style>
